import React from "react";

const ClubsContext = React.createContext({});

export default ClubsContext;
